import { useEffect, useRef } from "react";

const scriptId = "cloudflare-turnstile-script";
const siteKey = process.env.REACT_APP_AFTRPRTY_TURNSTILE_SITE_KEY;

function loadTurnstile() {
	if (window.turnstile) {
		return Promise.resolve(window.turnstile);
	}

	return new Promise((resolve, reject) => {
		const existingScript = document.getElementById(scriptId);
		const script = existingScript || document.createElement("script");

		script.addEventListener("load", () => {
			if (window.turnstile) {
				resolve(window.turnstile);
			} else {
				reject(new Error("Turnstile did not load."));
			}
		}, { once: true });
		script.addEventListener("error", () => reject(new Error("Turnstile failed to load.")), { once: true });

		if (!existingScript) {
			script.id = scriptId;
			script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
			script.async = true;
			script.defer = true;
			document.head.appendChild(script);
		}
	});
}

function TurnstileWidget({ onTokenChange }) {
	const containerRef = useRef(null);
	const widgetIdRef = useRef(null);

	useEffect(() => {
		let active = true;

		if (!siteKey) {
			onTokenChange(null);
			return undefined;
		}

		loadTurnstile()
			.then((turnstile) => {
				if (!active || !containerRef.current) {
					return;
				}

				widgetIdRef.current = turnstile.render(containerRef.current, {
					sitekey: siteKey,
					theme: "dark",
					callback: (token) => onTokenChange(token),
					"expired-callback": () => onTokenChange(null),
					"error-callback": () => onTokenChange(null),
				});
			})
			.catch(() => onTokenChange(null));

		return () => {
			active = false;
			if (widgetIdRef.current !== null && window.turnstile) {
				window.turnstile.remove(widgetIdRef.current);
			}
		};
	}, [onTokenChange]);

	if (!siteKey) {
		return <p role="alert">Security check is not configured.</p>;
	}

	return <div ref={containerRef} />;
}

export default TurnstileWidget;
